import { RuleAddPage } from "./RuleAddPage";
export default RuleAddPage;
